import { createFileRoute } from '@tanstack/react-router';

import { PageHeader } from '../../components/common/PageHeader';
import { SchedulesTabs } from '../../components/workflows/SchedulesTabs';
import { WorkflowSchedulesTable } from '../../components/workflows/WorkflowSchedulesTable';

/**
 * Org-wide list of workflow schedules (DEV-17470). Reached from Automation >
 * Schedules in the sidebar and from the "Workflow schedules" tab on the
 * refinement Scheduled sessions page. Creating a schedule happens on the
 * workflow page (Schedule button); this page is for seeing what fires when,
 * what last happened, and pausing or kicking one off.
 */
export const Route = createFileRoute('/schedules/')({ component: WorkflowSchedulesPage });

function WorkflowSchedulesPage() {
  return (
    <>
      <PageHeader title="Workflow schedules" />
      <SchedulesTabs />
      <WorkflowSchedulesTable />
    </>
  );
}
